export default {
      id: "circle-dictionary-usage",
      viewBox: "0 0 31 30",
      url: __webpack_public_path__ + "sprite-46b249.svg#circle-dictionary-usage",
      toString: function () {
        return this.url;
      }
    }